import http from '../../../../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_DASHBOARD}/executive_report`

const resourcesByClient = () => http.get(`${api}/resources_by_client_report`)

export {
  resourcesByClient
}
